import { Navigate } from "react-router-dom"
import { useContext, useState } from "react";
import AuthContext from "./AuthProvider";

const PrivateRoute = ({ children, ...rest }) => {
    const { user } = useContext(AuthContext)
    return !user?.is_super ? <Navigate to='/login' /> : children;
}

export default PrivateRoute;